const initMegaMenu = () => {
    const megaMenuContainer = document.querySelector("[data-mega-menu-container]");
    const openMegaMenuTogglerContainer = document.querySelector("[data-menu-toggler-container]");
    const closeMegaMenuTogglerContainer = megaMenuContainer.querySelector(".close-hamburger");
    const body = document.querySelector("body");
    if (megaMenuContainer && openMegaMenuTogglerContainer && closeMegaMenuTogglerContainer) {
        openMegaMenuTogglerContainer.addEventListener("click", () => {
            megaMenuContainer.classList.toggle("active");
            openMegaMenuTogglerContainer.classList.toggle("active");
            body.classList.toggle("no-scroll");
        });
        closeMegaMenuTogglerContainer.addEventListener("click", () => {
            megaMenuContainer.classList.toggle("active");
            openMegaMenuTogglerContainer.classList.toggle("active");
            body.classList.toggle("no-scroll");
        });
    }
};
